import React, { useEffect, useState } from "react";
import { Footer } from "./components/Footer";
import { LoadingComponent } from "./components/LoadingComponent";
import Logo from "./assets/logo.png";
const initial = {
  data: {
    litersPrice: 0,
    kilosPrice: 0,
  },
  loading: false,
  error: false,
};

export default function Home() {
  const [zipCode, setZipCode] = useState({
    code: "",
    error: false,
  });
  const [fetchData, setFetchData] = useState(initial);
  const { loading, data } = fetchData;
  const { code, error } = zipCode;
  const fade = "animate__animated animate__fadeIn";
  const fadeD = "animate__animated animate__fadeInDown";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const mainUrl = process.env.REACT_APP_MAIN_URL;
    const qid = process.env.REACT_APP_QID;
    if (code.length < 5) return setZipCode({ ...zipCode, error: true });
    const url = `${mainUrl}/prices?qid=${qid}&postalCode=${code}`;
    try {
      setFetchData({ data: initial, loading: true, error: false });
      const response = await fetch(url);
      const { kilosPrice, litersPrice }  = await response.json();

      setFetchData({
        data: { kilosPrice, litersPrice },
        loading: false,
        error: false,
      });
      // setTimeout(async () => {
      // }, 2000);
    } catch (error) {
      setFetchData({ data: initial, loading: false, error: true });
      // setTimeout(() => {
      //   setFetchData({ data: initial, loading: false, error: false });
      // }, 4000);
    }
  };

  const handleCancel = () => {
    setFetchData(initial);
  };


  useEffect(() => {
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }, []);

  return (
    <main className="main">
      <img
        src={Logo}
        width={200}
        height={200}
        alt="Global Gas"
        className={fade}
        style={{
          animationDelay: "1s",
        }}
      />
      <h1 className="title">Global Gas</h1>
      <form className={`zipcode__form ${fadeD}`}>
        <label>Ingrese su código postal</label>
        <input
          name="code"
          value={code}
          onChange={({ target }) =>
            setZipCode({ ...zipCode, code: target.value })
          }
          maxLength={5}
        />
        {error && <span>Ingrese un codigo postal valido</span>}
        <button  className="btn"onClick={handleSubmit} disabled={loading}>
          verificar Precios
        </button>
        {
          loading && <button
          onClick={handleCancel}
          className="btn btn-error"
        >
          Cancelar
        </button>
        }
      </form>

      {fetchData.loading && (
        <>
          
          <LoadingComponent />
        </>
      )}
      {fetchData.error && (
        <span className={`error ${fade}`} >
          No se encuentran precios registrados con ese codigo postal
        </span>
      )}
      {data.kilosPrice > 0 && data.litersPrice > 0 && (
        <div className={`products ${fade}`}>
          <h2>Precios de Gas</h2>
          {!fetchData.loading && !fetchData.error && (
            <div className="products_units">
              <h3>
                Precio por KG{" "}
                {data.kilosPrice && <strong>$ {data?.kilosPrice}</strong>}
              </h3>
              <p>|</p>
              <h3>
                Precio por LT{" "}
                {data.litersPrice && <strong>$ {data?.litersPrice}</strong>}
              </h3>
            </div>
          )}
        </div>
      )}
      <Footer />
    </main>
  );
}
